import type { DisplayTemplateAst } from './display-template';
import type { GlobalCollectionId, GlobalFieldId, GlobalSingleRelationFieldId } from './schema/ids';
import type { ResolvedMonospaceSingleRelationField } from './schema/resolved-schema';
import { isRecord } from '#layers/base/public';

export interface RelationQueryOptions {
	limit?: number;
	offset?: number;
	filter?: object;
}

export interface IdRelationQuery extends RelationQueryOptions {
	fields: IdFieldSelection;
	sort?: GlobalFieldId[];
}

export type IdFieldSelection = Array<
	GlobalFieldId | '*'
	| { [key: GlobalSingleRelationFieldId]: IdFieldSelection | IdRelationQuery }
>;

export interface RelationQuery extends RelationQueryOptions {
	fields: FieldSelection;
	sort?: string[];
}

export type FieldSelection = Array<
	string | '*'
	| { [relationApiName: string]: FieldSelection | RelationQuery }
>;

export function getPrimitiveFieldSelection(selection: FieldSelection): string[] {
	return selection.filter((e): e is string => typeof e === 'string');
}

export function getRelationFieldSelection(selection: FieldSelection): Array<Record<string, FieldSelection | RelationQuery>> {
	return selection.filter((e): e is Record<string, FieldSelection | RelationQuery> => typeof e !== 'string');
}

export function isRelationQuery(value: FieldSelection | RelationQuery): value is RelationQuery {
	return isRecord(value) && !Array.isArray(value) && 'fields' in value;
}

export function isIdRelationQuery(value: IdFieldSelection | IdRelationQuery): value is IdRelationQuery {
	return isRecord(value) && !Array.isArray(value);
}

export interface FieldSelectionContext {
	getDisplayTemplateFieldSelection: (ast: DisplayTemplateAst, collection: unknown) => IdFieldSelection;
	getCollection: (id: GlobalCollectionId) => unknown;
	getRelationField: (fieldId: GlobalSingleRelationFieldId) => ResolvedMonospaceSingleRelationField | undefined;
	resolveDisplayBlock: (displayId: string) => unknown;
}
